<template>
  <div class="d-flex flex-column mb-5">
    <div class="d-flex flex-column">
      <v-card class="d-flex mb-10 align-center pa-5" v-for="(n, i) in selected.langs">
        <v-select
          :items="[
            'Ukrainian',
            'Russian',
            'English',
            'Azerbaijani',
            'Chinese',
            'Hebrew',
            'Arabic',
            'French',
            'German',
          ]"
          v-model="n.name"
          outlined
          dense
          hide-details
          label="Language"
          class="mr-1"
        ></v-select>
        <v-select
          :items="[
            'Pre-intermediate',
            'Intermediate',
            'Upper-intermediate',
            'Advanced',
            'Native',
          ]"
          v-model="n.exp"
          outlined
          dense
          hide-details
          label="Experience"
          class="mr-1"
        ></v-select>
        
        <v-btn @click="selected.langs = selected.langs.filter((n, z_i) => z_i !== i)" fab small color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn 
          depressed 
          @click="selected.langs.push({
            name: '',
            exp: '',
          })" 
          color="primary"
        >
          add
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style>

</style>